import _ from 'lodash';
import moment from 'moment';
import { GRANULARITY_TYPES } from '../useProgressionOverTime/state.types';

const useGraphCategories = ({ data, granularity }) => {
  const orderedPeriods = _.orderBy(
    data,
    item => _.get(item, 'progression_data', []).length,
    'desc'
  );
  const periods = _.get(orderedPeriods, '[0].progression_data', []).map(
    item => ({
      startPeriod: _.get(item, 'start_period'),
      endPeriod: _.get(item, 'end_period')
    })
  );

  const mapGranularityToCategories = {
    [GRANULARITY_TYPES.MONTHLY.key]: () => {
      return periods.map(({ startPeriod }) =>
        moment(startPeriod).format('MMM')
      );
    },
    [GRANULARITY_TYPES.WEEKLY.key]: () => {
      return periods.map(
        ({ startPeriod }) =>
          `${moment(startPeriod).endOf('isoWeek').format('MMM D')}`
      );
    }
  };

  return mapGranularityToCategories[granularity.key]();
};

export default useGraphCategories;
